import { IconButton, Tooltip } from '@chakra-ui/react';
import { FiRefreshCw } from 'react-icons/fi';
import { useSharedData } from '../context/SharedDataContext';
import { SharingService } from '../services/SharingService';

const ReloadButton: React.FC = () => {
  const { shareData } = useSharedData();

  const handleReload = () => {
    if (!shareData) return;
    
    // Reconstruct the share URL from the share data
    const shareUrl = SharingService.createShareUrl(shareData);
    // Navigate to the share URL, which will trigger a reload
    window.location.href = shareUrl;
  };

  return (
    <Tooltip 
      label="Reload shared setup"
      placement="top"
    >
      <IconButton
        data-testid="reload-button"
        aria-label="Reload shared setup"
        icon={<FiRefreshCw size={36} />}
        onClick={handleReload}
        variant="ghost"
        size="lg"
        width="72px"
        height="72px"
        colorScheme="blue"
        _hover={{ 
          color: "accent.400",
          transform: 'scale(1.05)',
          borderColor: 'transparent'
        }}
        _active={{ 
          color: "accent.500",
          transform: 'scale(0.95)',
          borderColor: 'transparent'
        }}
        _focus={{ boxShadow: "none" }}
        _focusVisible={{ boxShadow: "none" }}
      />
    </Tooltip>
  );
};

export default ReloadButton;

